import { render, staticRenderFns } from "./ListNotifications.vue?vue&type=template&id=3902f48a"
import script from "./ListNotifications.vue?vue&type=script&lang=js"
export * from "./ListNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports